var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 11.875H3.75C3.40625 11.875 3.125 11.5938 3.125 11.25V3.75C3.125 3.40625 3.40625 3.125 3.75 3.125H6.875C7.21875 3.125 7.5 2.84375 7.5 2.5C7.5 2.15625 7.21875 1.875 6.875 1.875H3.125C2.43125 1.875 1.875 2.4375 1.875 3.125V11.875C1.875 12.5625 2.4375 13.125 3.125 13.125H11.875C12.5625 13.125 13.125 12.5625 13.125 11.875V8.125C13.125 7.78125 12.8438 7.5 12.5 7.5C12.1562 7.5 11.875 7.78125 11.875 8.125V11.25C11.875 11.5938 11.5938 11.875 11.25 11.875ZM8.75 2.5C8.75 2.84375 9.03125 3.125 9.375 3.125H10.9937L5.2875 8.83125C5.04375 9.075 5.04375 9.46875 5.2875 9.7125C5.53125 9.95625 5.925 9.95625 6.16875 9.7125L11.875 4.00625V5.625C11.875 5.96875 12.1562 6.25 12.5 6.25C12.8438 6.25 13.125 5.96875 13.125 5.625V2.5C13.125 2.15625 12.8438 1.875 12.5 1.875H9.375C9.03125 1.875 8.75 2.15625 8.75 2.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIn);
export default __webpack_public_path__ + "static/media/open_in.31c00abad79ffe519256e1b5c8c4272d.svg";
export { ForwardRef as ReactComponent };